import { useCallback } from 'react';

import { ButtonVariant, ContextDialog } from '@dreryk/react-components';

import { PreInterviewItem } from '../../../common/preInterview/PreInterviewPreviewItem.types';
import { visitDetailsTranslationKeys } from '../../../translations';
import { dispatchVisitDetailsCopyEvent } from '../VisitFormSynchronization.event';

type PreInterviewPreviewContextDialogConfirmButtonProps = {
   readonly hide: VoidFunction;
   readonly preInterviewItems: PreInterviewItem[];
};

export const PreInterviewPreviewContextDialogConfirmButton = (
   props: PreInterviewPreviewContextDialogConfirmButtonProps
): JSX.Element => {
   const handleClick = useCallback(() => {
      dispatchVisitDetailsCopyEvent({ interview: props.preInterviewItems });
      props.hide();

      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.hide, props.preInterviewItems]);

   return (
      <ContextDialog.ConfirmButton
         label={visitDetailsTranslationKeys.preInterview.dialog.actions.copy}
         variant={ButtonVariant.SECONDARY}
         onClick={handleClick}
      />
   );
};
